import script from "./IngressCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./IngressCards.vue?vue&type=script&setup=true&lang=ts"

import "./IngressCards.vue?vue&type=style&index=0&id=62b67174&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62b67174"]])

export default __exports__